angular.module('impactx.system').controller('EditGlobalMenuCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    '$context',
    '$workspace',
    EditGlobalMenuCtrl]);

function EditGlobalMenuCtrl($scope, dataGen, ToolbarService, $mdDialog, ToastService, TranslationService, $context, $workspace) {
    var self = this;

    dataGen.getData($scope, {}, '/systemadministration/editmenu/view').then(function () {
        defineButtons();
        $scope.labelMoveUp = TranslationService.get("moveUp");
        $scope.labelMoveDown = TranslationService.get("moveDown");
    });

    self.save = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/systemadministration/editmenu/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $context.invalidateSidebar(dataGen, $context, $workspace);
        });
    };

    self.delete = function () {
        return dataGen.postAsForm($scope, {}, "/systemadministration/editmenu/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
            $context.invalidateSidebar(dataGen, $context, $workspace);
        });
    };

    self.deleteImportantMenuItem = function (workspace, index) {
        workspace.importantMenuItems.splice(index, 1);
        for (var i = 0; i < workspace.importantMenuItems.length; i++) {
            workspace.importantMenuItems[i].xorder = i;
        }
    };

    self.openAddImportantMenuItemDialog = function (ev, workspace, selectedItem) {
        $mdDialog.show({
            controller: 'AddImportantMenuItemDialogCtrl',
            controllerAs: 'addImportantMenuItemDialogCtrl',
            templateUrl: 'modules/profile/templates/addimportantmenutitem.dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false,
            locals: {
                workspace: workspace,
                addImportantMenuItemsLabel: $scope.trns.addImportantMenuItems,
                chooseIconLabel: $scope.trns.chooseIcon,
                selectedItem: selectedItem
            }
        }).then(function (selectedItemToPush) {
            if (selectedItemToPush) {
                selectedItemToPush.xorder = workspace.importantMenuItems.length;
                workspace.importantMenuItems.push(selectedItemToPush);
            }
        }, angular.noop);
    };

    self.importantMenuItemDown = function (importantMenuItems, index) {
        if (index < importantMenuItems.length - 1) {
            var toMoveItem = importantMenuItems[index];
            toMoveItem.xorder++;
            importantMenuItems[index] = importantMenuItems[index + 1];
            importantMenuItems[index].xorder--;
            importantMenuItems[index + 1] = toMoveItem;
        }
    };

    self.importantMenuItemUp = function (importantMenuItems, index) {
        if (index > 0) {
            var toMoveItem = importantMenuItems[index];
            toMoveItem.xorder--;
            importantMenuItems[index] = importantMenuItems[index - 1];
            importantMenuItems[index].xorder++;
            importantMenuItems[index - 1] = toMoveItem;
        }
    };

   function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}